import {
  alertsActions,
  ticketActions,
  workdeskFilterActions,
  workdeskTicketsActions,
} from '.';
import getErrorMessage from 'utils/getErrorMessage';
import { manualSiConstants } from 'store/constants';
import { ticketDataSelector } from 'store/selectors';
import { ticketGroupTableSelectedIdsListSelector } from 'store/selectors/ticket-group-table.selector';
import { manualSiService } from 'store/services/manual-si.service';

const postMarkSiOfTicketIds = (ids: string[], si: boolean) => {
  return (dispatch) => {
    const ticketIdSiList = ids.map((id) => ({ id, si }));
    dispatch(postManyManualSi(ticketIdSiList));
  };
};

const postMarkSiOfSelectedTicketIds = (si: boolean) => {
  return (dispatch, getState) => {
    const ticketIds = ticketGroupTableSelectedIdsListSelector(
      getState(),
    );
    if (ticketIds && ticketIds.length) {
      dispatch(postMarkSiOfTicketIds(ticketIds, si));
    } else {
      console.warn(`no ticketIds selected`);
    }
  };
};

/**
 * mark si non-si
 * @param id
 * @param si
 */
const postManualSi = (id: string, si: boolean) => {
  return async (dispatch) => {
    dispatch(postManyManualSi([{ id, si }]));
  };
};

const postManyManualSi = (
  ticketIdSiList: { id: string; si: boolean }[],
) => {
  const ticketIds = ticketIdSiList.map((ticket) => ticket.id);
  const post = () => {
    return {
      type: manualSiConstants.MANY_MANUAL_SI_POST,
      payload: { ticketIdSiList },
    };
  };
  const failure = (ticketIds, error) => {
    return {
      type: manualSiConstants.MANY_MANUAL_SI_ERROR,
      payload: {
        ticketIds,
        error,
      },
    };
  };
  const success = (ticketIds) => {
    return {
      type: manualSiConstants.MANY_MANUAL_SI_SUCCESS,
      payload: { ticketIds },
    };
  };
  /**
   * @natchapol
   * QUESTION: what will the response be when failed some, succeeded some
   */
  return async (dispatch, getState) => {
    dispatch(post());

    manualSiService
      .postWorkdeskManualSi(ticketIdSiList)
      .then((tickets) => {
        const succeededIds = tickets.map((ticket) => ticket.id);
        dispatch(workdeskTicketsActions.updateTickets(tickets));
        dispatch(success(succeededIds));
        // find failed ids
        if (succeededIds.length !== ticketIdSiList.length) {
          const failedIds = ticketIdSiList.filter(
            (item) => !succeededIds.includes(item.id),
          );
          const errorMessage = `Couldn't update ${failedIds}`;
          dispatch(failure(failedIds, errorMessage));
          dispatch(alertsActions.error(errorMessage));
        }

        // update current ticket in case user trigger update si from the main page
        const currentTicket = ticketDataSelector(getState());

        if (
          currentTicket &&
          currentTicket.id &&
          succeededIds.includes(currentTicket.id)
        ) {
          const newTicket = tickets.find(
            (ticket) => ticket.id === currentTicket.id,
          );

          if (newTicket) {
            const siStatus = newTicket.si;
            dispatch(ticketActions.updateTicketSi(siStatus));

            if (newTicket.si !== undefined) {
              // toggle ticketType filter for workdesk page
              dispatch(
                workdeskFilterActions.selectTicketTypeIfNotCurrentFromSiValue(
                  newTicket.si,
                ),
              );
            }
          }
          // if couldn't find it. could mean user load main page directly (not clicked from the workdesk)
        }
      })
      .catch((error) => {
        const errorMessage = getErrorMessage(error);
        dispatch(failure(ticketIds, errorMessage));
        dispatch(alertsActions.error(errorMessage));
      });
  };
};

export const manualSiActions = {
  postManyManualSi,
  postManualSi,
  postMarkSiOfTicketIds,
  postMarkSiOfSelectedTicketIds,
};
